export default __webpack_public_path__ + "static/media/PTAR_JC.520efe56.png";